var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1CA14EA1-DD32-4231-BF0E-D3FCFC20549C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-page-stuff",
    transform: "translate(-51, -367)",
    stroke: "#C8C9CC",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(51, 367)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 11
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/group_1.35f61f8c0464bc9051239dfbaecc5dc6.svg";
export { ForwardRef as ReactComponent };